import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { filterTokenProps } from '../../../utils/filterTokenProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { ModalTransitionContextProvider } from '../../components/Modal/ModalTransitionContext';
import { jsx as _jsx } from "react/jsx-runtime";
const InnerMeasure = styled.span.withConfig({
  displayName: "HiddenMeasure__InnerMeasure",
  componentId: "bs5kft-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles, {
    overflow: 'hidden',
    position: 'absolute',
    left: 0,
    maxWidth: '100%',
    visibility: 'hidden',
    pointerEvents: 'none'
  });
});

// We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!
const hidePopoversContextValue = {
  transitioning: true
};
export const HiddenMeasure = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    tokenProps,
    restProps
  } = filterTokenProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(ModalTransitionContextProvider, {
    value: hidePopoversContextValue,
    children: /*#__PURE__*/_jsx(InnerMeasure, Object.assign({}, restProps, {
      ref: ref,
      $cssStyles: cssStyles
    }))
  });
});